import React from 'react';

const Inquiries = () => {
  const isUserRegistered = false; // Replace with actual authentication logic if needed.

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-800">
      {!isUserRegistered && (
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold mb-4">Access Restricted</h1>
          <p className="text-lg mb-4">
            Only registered users can access detailed use case listings. For early access,
            please contact{' '}
            <a href="mailto:info@ambivert.ai" className="text-blue-500 underline">
              info@ambivert.ai
            </a>
          </p>
        </div>
      )}

      <div className="p-6 bg-gray-50 text-gray-800 max-w-4xl">
        <h1 className="text-4xl font-bold mb-6 text-center">Discover AI Use Cases</h1>
        <p className="text-lg mb-4">
          Identifying relevant AI use cases is a critical step in any organization's journey
          toward AI adoption. It ensures alignment with business goals and maximizes ROI.
        </p>
        <p className="text-lg mb-4">
          Ambivert.ai helps businesses by leveraging a trained AI model to identify, evaluate,
          and implement AI use cases effectively. From advanced tools to curated use cases,
          we provide the insights you need to make informed decisions.
        </p>
        <p className="text-lg">
          Our platform is constantly evolving, incorporating the latest advancements in AI and
          feedback from industry experts to help businesses stay ahead in the AI revolution.
        </p>
      </div>
    </div>
  );
};

export default Inquiries;